import { MessageCircle } from "lucide-react";
import { useEffect, useState } from "react";
import odooApi, { buildWhatsAppUrl, DEFAULT_CONTACT_PHONE } from "../services/odooApi";
import { useLanguage } from "../contexts/LanguageContext";

export const WhatsAppFloat = () => {
  const { t } = useLanguage();
  const [whatsappNumber, setWhatsAppNumber] = useState(DEFAULT_CONTACT_PHONE);
  const message = t(
    "contact.whatsappGeneralPrefill",
    "Hello! I'm interested in renting a car from Velaris Royal.",
  );
  const whatsappUrl = buildWhatsAppUrl(whatsappNumber, message, '');

  useEffect(() => {
    let active = true;
    odooApi.getCmsConfig().then((config) => {
      if (active) {
        setWhatsAppNumber(config?.whatsapp || config?.phone || DEFAULT_CONTACT_PHONE);
      }
    });
    return () => {
      active = false;
    };
  }, []);

  if (whatsappUrl === '#') return null;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => odooApi.trackClick({ click_type: "whatsapp" })}
      className="whatsapp-float fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
      data-testid="whatsapp-float"
      aria-label={t("btn.chatWhatsApp", "Chat on WhatsApp")}
    >
      <MessageCircle className="w-7 h-7 text-white fill-white" />
    </a>
  );
};

export default WhatsAppFloat;
